<template>
  <tr>
    <td title="Klant">
      <BadgeComponent :customer="customer"/>
    </td>
    <td>
      <span v-if="hasAddress">
        {{ getProperty.street }} {{ getProperty.number }}{{ getProperty.number_addition }}<br>
        {{ getProperty.postal_code }} {{ getProperty.city }}
      </span>
      <span v-else>
        -
      </span>
    </td>
    <td>
      <span v-if="getEmail">
        <i class="mdi mdi-at" title="E-mail"></i> {{ getEmail }}
        <br>
      </span>
      <span v-if="getPhone">
          <i class="mdi mdi-phone" title="Telefoon"></i>
          <a :href="'tel:' + getPhone">{{ getPhone }}</a>
          <br>
        </span>
      <span v-if="getMobile">
          <i class="mdi mdi-cellphone" title="Mobiel"></i>
          <a :href="'tel:' + getMobile">{{ getMobile }}</a>
        </span>
    </td>
  </tr>
</template>

<script>
import BadgeComponent from "~/modules/customer/components/BadgeComponent";

export default {
  name: "SelectionCustomerRowComponent",
  components: {BadgeComponent},
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasAddress() {
      return (this.customer.current_visit_customer_property !== null
          && typeof this.customer.current_visit_customer_property !== 'undefined'
          && this.customer.current_visit_customer_property.data.property !== null
          && typeof this.customer.current_visit_customer_property.data.property !== 'undefined'
      );
    },
    getProperty() {
      const property = this.customer.current_visit_customer_property.data.property.data;

      if (property !== null && typeof property !== 'undefined' && Object.keys(property).length !== 0) {
        return {
          street: property.street,
          number: property.number,
          number_addition: property.number_addition ? property.number_addition : '',
          postal_code: property.postal_code.toUpperCase(),
          city: property.city ? property.city.charAt(0).toUpperCase() + property.city.slice(1) : '',
        };
      }
    },
    getEmail() {
      return this.customer.email_address;
    },
    getPhone() {
      return this.customer.phone;
    },
    getMobile() {
      return this.customer.mobile;
    },
  }
}
</script>